import { handlePagination, getAPIDataReturn } from "../../../utils/apiFunction";
import { dateFormat, textfieldDateFormat } from "../../../utils/dateFunctions";
import { numberFormat } from "../../../utils/numberFunctions";



const getBillData = async (workflowId, user, startDate, endDate, enableDateFilter, listOptions, abortController, setLoading, setData) => {

    setLoading(true);
    const queryParams = new URLSearchParams({
        workflowId: workflowId,
        user: user
    });

    if (listOptions?.includeAIRetraining) {
        queryParams.set('includeAIRetraining', 'true');
    }

    if (listOptions?.aiRetrainingOnly) {
        queryParams.set('aiRetrainingOnly', 'true');
    }

    if (enableDateFilter) {
        const startDateValue = startDate?.toISOString?.();
        const endDateValue = endDate?.toISOString?.();

        if (startDateValue) {
            queryParams.set('startDate', startDateValue);
        }

        if (endDateValue) {
            queryParams.set('endDate', endDateValue);
        }
    }

    const response = await getAPIDataReturn(('/APBills/Get?' + queryParams), abortController);

    var newData = response.map((data) => {
        var nObj = { ...data };
        const vendorName = data?.vendor?.name?.trim?.() || data?.vendor?.Name?.trim?.() || '';

        if (vendorName) {
            nObj.supplierName = vendorName;
        }

        if (nObj.amount !== null && nObj.amount !== undefined) {
            nObj.amount = "$" + numberFormat(Number(nObj.amount).toFixed(2));
        }
        console.log('nObj.status before: "', nObj.status, '"');
        if (nObj.status.trim() === 'Duplicate') {
            
            nObj.status &&= 'Duplicate (Id:' + nObj.duplicateId + ')';
            console.log('nObj.status after:', nObj.status);
        }
        return nObj;
    })

    setData(newData);
    setLoading(false);
}

export default getBillData;